import React, { useState } from 'react';
import apiClient from '../../apiClient';

const AddUserForm = ({ setMessage }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailID: '',
    phoneNumber: '',
    username: '',
    password: '',
    role: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: '', type: '' });
    try {
      const response = await apiClient.post('/api/register', formData);
      setMessage({ text: 'User added successfully!', type: 'success' });
      setFormData({
        firstName: '',
        lastName: '',
        emailID: '',
        phoneNumber: '',
        username: '',
        password: '',
        role: ''
      });
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || 'Failed to add user';
      setMessage({ text: errorMessage, type: 'error' });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="add-user-form">
      <div>
        <label>First Name:</label>
        <input name="firstName" value={formData.firstName} onChange={handleChange} required />
      </div>
      <div>
        <label>Last Name:</label>
        <input name="lastName" value={formData.lastName} onChange={handleChange} required />
      </div>
      <div>
        <label>Email ID:</label>
        <input type="email" name="emailID" value={formData.emailID} onChange={handleChange} required />
      </div>
      <div>
        <label>Phone Number:</label>
        <input name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
      </div>
      <div>
        <label>Username:</label>
        <input name="username" value={formData.username} onChange={handleChange} required />
      </div>
      <div>
        <label>Password:</label>
        <input type="password" name="password" value={formData.password} onChange={handleChange} required />
      </div>
      <div>
        <label>Role:</label>
        <input name="role" value={formData.role} onChange={handleChange} required />
      </div>
      <button type="submit">Add User</button>
    </form>
  );
};

export default AddUserForm;
